{
  "validation.maxAttachments": "Seules {{max}} pièces jointes sont autorisées.",
  "validation.minAttachments": "",
  "validation.maxAttachmentSize": "Les pièces jointes ne peuvent pas faire plus de {{max}} mégaoctets.",
  "validation.attachmentListItemRequired": "Merci d’ajouter une pièce jointe pour « {{category}} ».",
  "validation.attachmentListItemMaxAttachments": "Seules {{max}} pièces jointes sont autorisées pour la catégorie « {{category}} ».",
  "validation.attachmentListItemMaxAttachmentSize": "Les pièces jointes pour {{category}} ne peuvent pas dépasser {{max}} mégaoctets.",
  "attachment.bsoCategory.DiagnosticReport": "Rapport de diagnostic",
  "attachment.bsoCategory.InvoiceDocument": "Facture",
  "attachment.bsoCategory.ShippingDocument": "Document d’expédition",
  "attachment.bsoCategory.Letter": "Lettre",
  "attachment.bsoCategory.PictureReference": "Photo de référence",
  "attachment.bsoCategory.BugReport": "Rapport d'erreur",
  "attachment.bsoCategory.Other": "Autre",
  "attachment.bsoCategory.Unclassified": "Non classé",
  "attachment.bsoCategory.ServiceForms": "Formulaire de service",
  "attachment.bsoCategory.RegistrationDocument": "Document d’inscription",
  "attachment.bsoCategory.ShopInside": "Photo de l’intérieur du magasin",
  "attachment.bsoCategory.ShopImageMigration": "Migration d’image du magasin",
  "attachment.bsoCategory.ShopImage": "Photo de la devanture du magasin",
  "attachment.uploadButton": "Télécharge {{category}}",
  "attachment.uploadDropdown": "Télécharge un fichier"
}